exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification-container{border:1px solid #e4e4e4}.notification-text{padding:10px 20px;color:#fd6c00;font-weight:700;font-size:1.25rem}.notification-text a{text-decoration:underline}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Notification/Notification.scss
 ** module id = 1204
 ** module chunks = 0
 **/